import { ContainerJourneysApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { ContainerJourneyNonNumericFilter } from '@planning/pages/ServiceOrders/Models/NonNumeric.model'

class ContainerJourneysService {
  httpClient = createApiClient(ContainerJourneysApi)

  async get(containerIds: number[], includeCompleted?: boolean, includeRestow?: boolean) {
    const { data } = await this.httpClient.getByContainerIds({
      containerIds,
      includeCompleted,
      includeRestow,
    })

    return data
  }

  async getByContainerNumbers(containerNumbers: string[]) {
    const { data } = await this.httpClient.getByContainerNumbers(containerNumbers, false)

    return data
  }

  async getByNonNumeric({
    length,
    height,
    type,
    operator,
    isoCode,
  }: ContainerJourneyNonNumericFilter) {
    const { data } = await this.httpClient.getByNonNumeric(
      length ? +length : undefined,
      height,
      type,
      operator,
      isoCode,
    )

    return data
  }

  async getByOrderIds(orderIds?: Array<number>) {
    const { data } = await this.httpClient.getByOrderIds(orderIds)

    return data
  }

  async getByPartialContainerNumber(partialContainerNumber: string, isOnTerminal?: boolean) {
    const { data } = await this.httpClient.getByPartialContainerNumber(
      partialContainerNumber,
      isOnTerminal,
    )

    return data
  }
}

const containerJourneysService = new ContainerJourneysService()

export default containerJourneysService
